import { DateTime } from 'luxon';
import { CoordinateApiModel } from '../coordinate.api-model';
import type { ILinkDetails } from '../../../../models/link-details.model';
import type { TransportMode } from '../../../../models/transport-mode.enum';
import type { TransportSubMode } from '../../../../models/transport-sub-mode.enum';

export class LinkDetailsApiModel {
  public static mapToBusinessModel(apiModel: LinkDetailsApiModel | undefined): ILinkDetails | undefined {
    if (!apiModel) return undefined;
    return {
      distanceInMeters: apiModel.distanceInMeters,
      estimatedNumberOfSteps: apiModel.estimatedNumberOfSteps,
      linkCoordinates: apiModel.linkCoordinates ? apiModel.linkCoordinates.map(CoordinateApiModel.mapToBusinessModel) : undefined,
      plannedArrivalTime: apiModel.plannedArrivalTime ? DateTime.fromISO(apiModel.plannedArrivalTime) : undefined,
      plannedDepartureTime: apiModel.plannedDepartureTime ? DateTime.fromISO(apiModel.plannedDepartureTime) : undefined,
      transportMode: apiModel.transportMode,
      transportSubMode: apiModel.transportSubMode,
    };
  }

  public linkCoordinates?: CoordinateApiModel[];
  public distanceInMeters?: number;
  public estimatedNumberOfSteps?: number;
  public plannedDepartureTime?: string;
  public plannedArrivalTime?: string;
  public transportMode!: TransportMode;
  public transportSubMode!: TransportSubMode;
}
